import type { Theme, Components } from '@mui/material/styles';
import type { SettingsState } from 'src/components/settings';

import { cardClasses } from '@mui/material/Card';

// ----------------------------------------------------------------------

export function applySettingsToComponents(settingsState?: SettingsState): {
  components: Components<Theme>;
} {
  const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
    styleOverrides: (theme) => ({
      html: {
        fontSize: settingsState?.fontSize,
        // Crisper, thinner text on macOS — Inter renders heavy on dark
        // backgrounds without this. Ignored on other platforms.
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
      // Typeset wrapping app-wide: even line lengths on short headings, no
      // orphaned last words in body copy. Browsers ignore balance past ~6 lines.
      'h1, h2, h3, h4': {
        textWrap: 'balance',
      },
      'p, li, blockquote, figcaption': {
        textWrap: 'pretty',
      },
      body: {
        [`& .${cardClasses.root}`]: {
          ...(settingsState?.contrast === 'high' && {
            '--card-shadow': theme.vars.customShadows.z1,
          }),
        },
      },
    }),
  };

  return {
    components: {
      MuiCssBaseline,
    },
  };
}
